module.exports = __webpack_public_path__ + "cc23f2301272066041a698bdec860c12.png";